import axios from "axios";

interface Params {
    token: string;
    refreshToken: string;
}

const setAuthToken = ({ token, refreshToken }: Params) => {
    if (token) {
        axios.defaults.headers.common.Authorization = `Bearer ${ token }`;
        localStorage.setItem("access-token", token);
        localStorage.setItem("refresh-token", refreshToken);
    } else {
        delete axios.defaults.headers.common.Authorization;
        localStorage.setItem("access-token", "");
        localStorage.setItem("refresh-token", refreshToken);
    }
};

export default setAuthToken;
